import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Copy, Check } from 'lucide-react';
import { copyToClipboard } from '@/lib/clipboard';

// CopyButton — универсальное копирование в буфер обмена (web/PWA/desktop/WebView2):
// navigator.clipboard.writeText (secure context) с fallback на execCommand('copy')
// (работает в WebView2, где clipboard API может быть недоступен).
// После копирования — «Скопировано» (1.5с). Любой текст — кнопка рядом.
interface CopyButtonProps {
  text: string;
  label?: string;
  compact?: boolean;
  className?: string;
}

export function CopyButton({ text, label = 'Копировать', compact, className }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const copy = async () => {
    setError(null);
    try {
      await copyToClipboard(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e: any) {
      setError(e?.message || 'Не удалось скопировать');
    }
  };

  return (
    <span className={`inline-flex items-center gap-1 ${className || ''}`}>
      <Button
        size="sm"
        variant="ghost"
        className="h-5 px-1.5 text-[10px]"
        onClick={() => void copy()}
        title={error || 'Копировать в буфер обмена'}
      >
        {copied ? <Check className="h-3 w-3 text-green-600" /> : <Copy className="h-3 w-3" />}
        {!compact && <span className="ml-0.5">{copied ? 'Скопировано' : label}</span>}
      </Button>
      {error && <span className="text-[10px] text-destructive">{error}</span>}
    </span>
  );
}
